import React, { useState, useContext, useEffect, useRef } from "react";
import "../../styles/offsetting.css";
import loader2 from "../../images/loader_2.gif";
import ApiService from "../../api/apiService";
import showSwal from "../swal";
import { common } from "../../util/common";
import { convertTo12HourPlusDateFormat } from "../../util/helperFunctions";
import "../../styles/so-lo-form.css";

function OffsettingForm({ formDetails, setReferenceId, setDateAndTime, setFormSubmitted }) {
  const loaderRef = useRef(null);

  const [isSubmitting, setSubmitting] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");

  const [images, setImages] = useState(null);

  const [formData, setFormData] = useState({
    specificAddress: "",
    companyName: "",
    contactName: "",
    position: "",
    mobileNumber: null,
    telephone1: null,
    telephone2: null,
    supplier: null,
    volume: null,
    prospectsEmail: null,
  });

  const handleImageChange = (event) => {
    const files = event.target.files;
    setImages(files);
  };

  const handleDataChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleRegionChange = (event) => {
    setSelectedRegion(event.target.value);
    setSelectedProvince("");
  };

  const ncSources = ["Delivery (Customer Complaint)", "Quality (Customer Complaint)", "Audit", "Incident Report"];
  const warehouses = [
    "Bacolod",
    "Bohol",
    "Cavite Depot",
    "NCR",
    "Ormoc",
    "Starport Mindoro",
    "Tacloban",
    "Top Armada Mindoro",
    "Other",
  ];

  const requestTypes = [
    "SO/LO - Republic Cement",
    "SO - Century Peak",
    "ATW/SO - Union Phil Cement (Union Cement)",
    "ATW and COF for Mabuhay Cement",
    "Other",
  ];

  const handleSubmit = async (e) => {
    const {
      specificAddress,
      companyName,
      position,
      mobileNumber,
      telephone1,
      telephone2,
      supplier,
      volume,
      prospectsEmail,
    } = formData;

    const _formData = new FormData();
    _formData.append("specificAddress", specificAddress);
    _formData.append("companyName", companyName);
    _formData.append("position", position);
    _formData.append("mobileNumber", mobileNumber);
    _formData.append("telephone1", telephone1);
    _formData.append("telephone2", telephone2);
    _formData.append("supplier", supplier);
    _formData.append("volume", volume);
    _formData.append("prospectsEmail", prospectsEmail);

    if (images) {
      for (let i = 0; i < images.length; i++) {
        _formData.append("prospectingImages", images[i]);
      }
    }

    e.target.style.display = "none";
    loaderRef.current.style.display = "inline-block";

    const response = await ApiService.forms.submitProspectingRequest(formDetails.id, _formData);
    const { success, prospecting } = response;
    if (!success) return showSwal(common.errors.SUBMIT_OFFSET_FORM_ERROR);
    setSubmitting(false);
    e.target.style.display = "block";
    loaderRef.current.style.display = "none";
    setReferenceId(prospecting.reference_id);
    setDateAndTime(convertTo12HourPlusDateFormat(prospecting.createdAt));
    setFormSubmitted(true);
  };

  return (
    <div className='epr-form-container'>
      <div className='epr-title'>
        <h3>SO/LO Requisition</h3>
      </div>
      <div className='epr-form-body'>
        <div className='epr-form-groupings'>
          <div className='epr-form-group'>
            <div className='epr-form-fields-prospecting'>
              <label htmlFor='region'>
                Type of Request<span className='epr-required'>*</span>
              </label>
              <select name='region' id='region' value={selectedRegion} onChange={handleRegionChange}>
                <option value=''>Select Request Type</option>
                {requestTypes.map((request, index) => (
                  <option value={request} key={`${index}-${request}`}>
                    {request}
                  </option>
                ))}
              </select>
            </div>
            <div className='epr-form-fields-prospecting'>
              <div className='epr-form-checkbox-label'>
                <label htmlFor=''>Urgent</label>
              </div>
              <div className='epr-form-checkbox'>
                <input type='checkbox' id='urgent' />
                <label htmlFor='urgent'>Yes</label>
              </div>
            </div>
          </div>
          <div className='epr-form-group'>
            <div className='epr-form-fields-prospecting'>
              <label htmlFor=''>Date Needed</label>
              <input type='date' />
            </div>
          </div>
          <div className='epr-form-group'>
            <div className='epr-form-group'>
              <div className='epr-form-fields-prospecting'>
                <label htmlFor=''>Description of Request</label>
                <textarea onChange={(e) => handleDataChange("specificAddress", e.target.value)} />
              </div>
            </div>
            <div className='epr-form-fields-prospecting'>
              <label htmlFor='images'>Signature</label>
              <input type='file' id='images' multiple onChange={handleImageChange} />
            </div>
          </div>
        </div>
        <div className='epr-submit-action-btn'>
          <button className='epr-submit-request' onClick={(e) => handleSubmit(e)}>
            <span className='epr-form-btn-txt'>Submit Request</span>
            <img src={loader2} className='epr-form-loader' style={{ display: "none" }} ref={loaderRef} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default OffsettingForm;
